(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
          const getContent = el.querySelector('[data-collapsible-content]');
          if(getContent){
            getContent.style.opacity = '1';
          }
        }
      });
    };
    applyAccordionState();
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    mobileQuery.addEventListener('change', () => {
      applyAccordionState();
    });
    // window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.style.setProperty(
        '--progress_width',
        `${(parseInt(this.dataset.value) * 0.75 * 100) / parseInt(this.dataset.max)}%`
      );
    }
  }
  customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-air-in-motion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('onair-motion-cinema')) {
  customElements.define('onair-motion-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.assetsReady = false;
      this.stanceVisible = this.springVisible = this.roadVisible = !('IntersectionObserver' in window);
      this.demoWanted = this.dataset.intro === 'true';
      this.demoManual = false; this.roadWanted = true;
      this.timers = new Set(); this.pendingDemo = null;
      this.abort = new AbortController();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
       this.mobileMotion = window.matchMedia('(max-width: 700px)').matches;
      this.removeAttribute('data-visual-ready');
      this.carBody = this.querySelector('[data-car-body]');
      this.range = this.querySelector('[data-height-slider]');
      this.springNodes = this.strutNodes('spring'); this.rideNodes = this.strutNodes('ride');
      this.roadNodes = Object.fromEntries(['front', 'rear', 'body', 'travel'].map(key => [key, this.querySelector('[data-ride-' + key + ']')]));
      this.roadSurface = this.querySelector('[data-road-surface]');
      this.roadFill = this.querySelector('[data-road-fill]');
      this.roadLane = this.querySelector('[data-road-lane]');
      this.roadTrack = this.querySelector('[data-road-track]');
      this.rideVehicle = this.querySelector('[data-ride-vehicle]');
      this.rims = Array.from(this.querySelectorAll('[data-ride-rim]'));
      this.glint = this.querySelector('[data-ride-glint]');
      this.roadState = { travel: 1290, body: 0, velocity: 0, pitch: 0, pitchVelocity: 0, frontSuspension: 0, rearSuspension: 0 };
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        this.transition?.skipTransition();
        if (button.matches('[data-view]')) this.changeView(button.dataset.view);
        if (button.matches('[data-height]')) {
          this.demoWanted = false; this.stopDemo(); this.setHeight(Number(button.dataset.height), true);
        }
        if (button.matches('[data-demo]')) {
          if (this.running || this.pendingDemo !== null) { this.demoWanted = false; this.stopDemo(); }
          else { this.demoWanted = true; this.demoManual = true; this.beginDemo(); }
        }
        if (button.matches('[data-spring-part]')) this.selectSpring(button.dataset.springPart);
        if (button.matches('[data-ride-topic]')) this.selectRideTopic(button.dataset.rideTopic);
        if (button.matches('[data-road-toggle]')) {
          this.roadWanted = !this.roadWanted; this.syncMotion();
        }
      }, options);
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-height-slider]')) return;
        this.demoWanted = false; this.stopDemo(); this.setHeight(Number(event.target.value), false);
      }, options);
      this.addEventListener('keydown', event => {
        if (!event.target.matches('[role="tab"]')) return;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const index = tabs.indexOf(event.target);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); this.changeView(tabs[next].dataset.view); tabs[next].focus();
      }, options);
      this.reduced.addEventListener('change', () => this.configureMotion(), options);
      document.addEventListener('visibilitychange', () => this.syncMotion(), options);
      this.goal = 100; this.value = 100;
      this.setHeight(100, false); this.switchView('stance');
      this.selectSpring('air'); this.selectRideTopic('absorb');
      this.buildRoadTrack(); this.renderRoad(0, 0, 0, 0, this.roadState.travel); this.setFlow('hold'); this.configureMotion();
      this.setAttribute('data-ready', '');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.stanceVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .65);
          this.syncMotion();
        }, { threshold: [0, .65] });
        this.observer.observe(this.querySelector('.om2__car-scene'));
        this.springObserver = new IntersectionObserver(entries => {
          this.springVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .4);
          this.syncMotion();
        }, { threshold: [0, .4] });
        this.springObserver.observe(this.querySelector('.om2__spring-scene'));
        this.roadObserver = new IntersectionObserver(entries => {
          this.roadVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
          this.syncMotion();
        }, { threshold: [0, .25] });
        this.roadObserver.observe(this.querySelector('.om2__road-scene'));
      }
      this.buildWheelPlanes(); this.loadVisuals();
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.transition?.skipTransition(); this.stopDemo(); this.stopRoad(false); this.abort.abort();
      this.observer?.disconnect(); this.springObserver?.disconnect(); this.roadObserver?.disconnect();
      this.initialized = false;
    }
    strutNodes(prefix) {
      return Object.fromEntries(['bellow', 'grain', 'cavity', 'clip', 'rib', 'seam', 'highlight', 'top', 'rod'].map(key => [key, this.querySelector('[data-' + prefix + '-' + key + ']')]));
    }
    buildWheelPlanes() {
      const namespace = 'http://www.w3.org/2000/svg';
      const defs = this.querySelector('.om2__assets defs');
      const rimId = this.querySelector('[id$="-rolling-rim"]').id;
      const element = (name, attributes) => {
        const node = document.createElementNS(namespace, name);
        Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
        return node;
      };
      this.querySelectorAll('[data-wheel-mesh]').forEach(plane => {
        if (plane.childElementCount) return;
        const h = plane.dataset.projection.split(' ').map(Number);
        const project = ([u, v]) => {
          const w = h[6] * u + h[7] * v + 1;
          return [(h[0] * u + h[1] * v + h[2]) / w, (h[3] * u + h[4] * v + h[5]) / w];
        };
        const outline = Array.from({ length: 96 }, (_, i) => project([Math.cos(i * Math.PI / 48), Math.sin(i * Math.PI / 48)]));
        const outlineId = rimId + '-' + plane.dataset.wheelMesh + '-outline';
        const outlineClip = element('clipPath', { id: outlineId, clipPathUnits: 'userSpaceOnUse' });
        outlineClip.append(element('polygon', { points: outline.map(p => p.join(',')).join(' ') }));
        defs.append(outlineClip); plane.setAttribute('clip-path', 'url(#' + outlineId + ')');
        let index = 0;
        const slices = this.mobileMotion ? 3 : 8;
        const increment = 2 / slices;
        for (let row = 0; row < slices; row++) {
          for (let column = 0; column < slices; column++) {
            const u = -1 + column * increment, v = -1 + row * increment;
            const triangles = [[[u, v], [u + increment, v], [u + increment, v + increment]], [[u, v], [u + increment, v + increment], [u, v + increment]]];
            triangles.forEach(points => {
              const target = points.map(project);
              const [[x0, y0], [x1, y1], [x2, y2]] = points;
              const denominator = (x1 - x0) * (y2 - y0) - (x2 - x0) * (y1 - y0);
              const solve = axis => {
                const d1 = target[1][axis] - target[0][axis], d2 = target[2][axis] - target[0][axis];
                const a = (d1 * (y2 - y0) - d2 * (y1 - y0)) / denominator;
                const c = ((x1 - x0) * d2 - (x2 - x0) * d1) / denominator;
                return [a, c, target[0][axis] - a * x0 - c * y0];
              };
              const [a, c, e] = solve(0), [b, d, f] = solve(1);
              const clipId = rimId + '-' + plane.dataset.wheelMesh + '-' + index++;
              const center = [(x0 + x1 + x2) / 3, (y0 + y1 + y2) / 3];
              const expanded = points.map(p => p.map((value, axis) => center[axis] + (value - center[axis]) * 1.018));
              const clip = element('clipPath', { id: clipId, clipPathUnits: 'userSpaceOnUse' });
              clip.append(element('polygon', { points: expanded.map(p => p.join(',')).join(' ') }));
              defs.append(clip);
              const tile = element('g', { transform: 'matrix(' + [a, b, c, d, e, f].map(n => n.toFixed(6)).join(' ') + ')' });
              const face = element('g', { 'clip-path': 'url(#' + clipId + ')' });
              face.append(element('use', { href: '#' + rimId })); tile.append(face); plane.append(tile);
            });
          }
        }
      });
    }
    loadVisuals() {
      const signal = this.abort.signal;
      const urls = Array.from(new Set(Array.from(this.querySelectorAll('.om2__assets image')).map(image => image.getAttribute('href'))));
      Promise.all(urls.map(url => new Promise(resolve => {
        const image = new Image();
        image.onload = () => resolve(true); image.onerror = () => resolve(false);
        image.decoding = 'async'; image.src = url;
        if (image.complete && image.naturalWidth > 0) resolve(true);
      }))).then(results => {
        if (signal.aborted || !this.initialized) return;
        this.assetsReady = results.every(Boolean); this.toggleAttribute('data-visual-ready', this.assetsReady);
        this.syncMotion();
      });
    }
    heightEligible() {
      return this.demoWanted && this.assetsReady && !this.reduced.matches && !document.hidden &&
        ((this.dataset.view === 'stance' && this.stanceVisible) || (this.dataset.view === 'spring' && this.demoManual && this.springVisible));
    }
    syncMotion() {
      if (this.heightEligible()) {
        if (!this.running && this.pendingDemo === null) {
          this.pendingDemo = this.later(() => { this.pendingDemo = null; if (this.heightEligible()) this.beginDemo(); }, 1250);
          this.demoUI(true);
        }
      } else if (this.running || this.pendingDemo !== null || (document.hidden && this.frame !== null)) this.stopDemo();
      const roadBox = this.dataset.view === 'ride' ? this.querySelector('.om2__road-scene')?.getBoundingClientRect() : null;
      const roadOnScreen = !!roadBox && roadBox.height > 0 && roadBox.bottom > 0 && roadBox.top < window.innerHeight * .97;
      const roadEligible = this.roadWanted && this.assetsReady && !this.reduced.matches && !document.hidden && this.dataset.view === 'ride' && (this.roadVisible || roadOnScreen);
      if (roadEligible && !this.roadRunning) this.startRoad();
      else if (!roadEligible) this.stopRoad(false);
    }
    configureMotion() {
      this.toggleAttribute('data-reduced', this.reduced.matches);
      this.querySelector('[data-road-toggle]').disabled = this.reduced.matches;
      this.querySelector('[data-demo]').disabled = this.reduced.matches;
      this.querySelector('[data-road-reduced]').hidden = !this.reduced.matches;
      if (this.reduced.matches) this.stopDemo();
      this.syncMotion();
    }
    later(action, delay) {
      const id = setTimeout(() => { this.timers.delete(id); action(); }, delay);
      this.timers.add(id); return id;
    }
    switchView(view) {
      this.dataset.view = view;
      this.querySelectorAll('[data-height-label-view]').forEach(label => { label.hidden = label.dataset.heightLabelView !== (view === 'spring' ? 'spring' : 'stance'); });
      this.updateHeightText();
      this.querySelectorAll('[role="tab"]').forEach(tab => {
        const active = tab.dataset.view === view;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== view; });
      this.syncMotion();
    }
    changeView(view) {
      this.transition?.skipTransition();
      if (!document.startViewTransition || this.reduced.matches || window.matchMedia('(max-width:700px)').matches) { this.switchView(view); return; }
      this.style.viewTransitionName = 'onair-motion-cinema';
      this.transition = document.startViewTransition(() => this.switchView(view));
      this.transition.ready.catch(() => {});
    }
    selectSpring(part) {
      this.querySelectorAll('[data-spring-part]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.springPart === part)));
      this.querySelectorAll('[data-spring-copy]').forEach(copy => { copy.hidden = copy.dataset.springCopy !== part; });
      this.querySelector('.om2__spring-scene').dataset.springSelection = part;
    }
    selectRideTopic(topic) {
      this.querySelectorAll('button[data-ride-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rideTopic === topic)));
      this.querySelectorAll('[data-ride-copy]').forEach(copy => { copy.hidden = copy.dataset.rideCopy !== topic; });
      this.querySelector('[data-panel="ride"]').dataset.rideTopic = topic;
    }
    setHeight(height, animate, duration = 1150) {
      const next = Math.max(0, Math.min(100, height));
      const previous = this.goal; this.goal = next;
      const state = next === 0 ? 'low' : next === 55 ? 'drive' : next === 100 ? 'lift' : 'custom';
      this.dataset.heightState = state;
      const lesson = this.querySelector('[data-lesson="' + state + '"]');
      this.querySelectorAll('[data-lesson]').forEach(item => { item.hidden = item !== lesson; });
      this.querySelectorAll('[data-height]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.height) === next)));
      this.updateHeightText();
      if (next !== previous) this.setFlow(next > previous ? 'raise' : 'lower', duration + 400);
      cancelAnimationFrame(this.frame); this.frame = null;
      if (!animate || this.reduced.matches) { this.render(next); return; }
      const from = this.value; const started = performance.now();
      const step = now => {
        const progress = Math.min(1, (now - started) / duration);
        const eased = progress < .5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        this.render(from + (next - from) * eased);
        this.frame = progress < 1 ? requestAnimationFrame(step) : null;
      };
      this.frame = requestAnimationFrame(step);
    }
    updateHeightText() {
      const preset = this.querySelector('[data-height][aria-pressed="true"]');
      const label = preset?.querySelector('[data-height-label-view]:not([hidden])');
      const lesson = this.querySelector('[data-lesson]:not([hidden]) strong');
      this.range.setAttribute('aria-valuetext', (label || preset || lesson).textContent.trim());
    }
    render(height) {
      this.value = height; this.range.value = String(height);
      this.style.setProperty('--om2-height', height.toFixed(2));
      const bodyShift = 26 - height * .48;
      this.carBody.setAttribute('transform', 'translate(0,' + bodyShift.toFixed(2) + ')');
      const compression = height < 55 ? 330 * Math.pow((55 - height) / 55, 1.1) : -42 * (height - 55) / 45;
      this.renderStrut(this.springNodes, compression);
      this.style.setProperty('--om2-bag-shift', (compression / 2).toFixed(2) + 'px');
    }
    renderStrut(nodes, offset) {
      const t = 300 + Math.max(-80, Math.min(330, offset));
      const b = 760; const h = b - t; const m = (t + b) / 2;
      const bulge = Math.max(-4, (t - 300) * .055);
      const left = 324 - bulge; const right = 700 + bulge;
      const outer = 'M376 ' + t + 'C344 ' + t + ' ' + left + ' ' + (t + h * .05) + ' ' + left + ' ' + (t + h * .18) +
        'C' + left + ' ' + (t + h * .31) + ' 343 ' + (t + h * .43) + ' 369 ' + (t + h * .46) +
        'Q392 ' + m + ' 369 ' + (t + h * .54) + 'C343 ' + (t + h * .57) + ' ' + left + ' ' + (t + h * .69) + ' ' + left + ' ' + (t + h * .82) +
        'C' + left + ' ' + (t + h * .95) + ' 344 ' + b + ' 376 ' + b + 'H648C680 ' + b + ' ' + right + ' ' + (t + h * .95) + ' ' + right + ' ' + (t + h * .82) +
        'C' + right + ' ' + (t + h * .69) + ' 681 ' + (t + h * .57) + ' 655 ' + (t + h * .54) +
        'Q632 ' + m + ' 655 ' + (t + h * .46) + 'C681 ' + (t + h * .43) + ' ' + right + ' ' + (t + h * .31) + ' ' + right + ' ' + (t + h * .18) +
        'C' + right + ' ' + (t + h * .05) + ' 680 ' + t + ' 648 ' + t + 'Z';
      nodes.bellow.setAttribute('d', outer); nodes.grain.setAttribute('d', outer); nodes.clip.setAttribute('d', outer);
      const innerRight = right - 16;
      const edge = Math.min(17, h * .09);
      const cavity = 'M532 ' + (t + edge) + 'H644C668 ' + (t + edge) + ' ' + innerRight + ' ' + (t + h * .08) + ' ' + innerRight + ' ' + (t + h * .19) +
        'C' + innerRight + ' ' + (t + h * .32) + ' 663 ' + (t + h * .41) + ' 644 ' + (t + h * .45) +
        'Q614 ' + m + ' 644 ' + (t + h * .55) + 'C663 ' + (t + h * .59) + ' ' + innerRight + ' ' + (t + h * .68) + ' ' + innerRight + ' ' + (t + h * .81) +
        'C' + innerRight + ' ' + (t + h * .92) + ' 668 ' + (b - edge) + ' 644 ' + (b - edge) + 'H532Z';
      nodes.cavity.setAttribute('d', cavity);
      nodes.rib.setAttribute('d', 'M' + (left + 12) + ' ' + (t + h * .18) + 'Q419 ' + (t + h * .25) + ' 494 ' + (t + h * .18) + 'M' + (left + 12) + ' ' + (t + h * .82) + 'Q419 ' + (t + h * .89) + ' 494 ' + (t + h * .82));
      nodes.seam.setAttribute('d', 'M350 ' + m + 'Q430 ' + (m + h * .037) + ' 513 ' + m);
      nodes.seam.setAttribute('stroke-width', Math.max(5, h * .0195).toFixed(2));
      nodes.rib.setAttribute('opacity', (.35 + Math.min(1, Math.max(0, offset / 330)) * .2).toFixed(3));
      nodes.highlight.setAttribute('d', 'M' + (left + 23) + ' ' + (t + h * .2) + 'Q' + (left + 16) + ' ' + (t + h * .39) + ' 380 ' + (t + h * .45) + 'M380 ' + (t + h * .55) + 'Q' + (left + 16) + ' ' + (t + h * .61) + ' ' + (left + 23) + ' ' + (t + h * .8));
      const shift = (t - 300).toFixed(2);
      nodes.top.setAttribute('transform', 'translate(0,' + shift + ')');
      nodes.rod.setAttribute('transform', 'translate(0,' + shift + ')');
    }
    setFlow(flow, duration) {
      clearTimeout(this.flowTimer); this.flowTimer = null; this.dataset.flow = flow;
      this.querySelector('[data-flow-label]').textContent = this.dataset[flow];
      if (flow !== 'hold') this.flowTimer = setTimeout(() => this.setFlow('hold'), duration || 1550);
    }
    demoUI(active) {
      this.querySelector('[data-demo]').setAttribute('aria-pressed', String(active));
      this.querySelector('[data-demo-label]').textContent = active ? this.dataset.stop : this.dataset.play;
      this.querySelector('[data-demo] .om2__play').textContent = active ? 'Ⅱ' : '▶';
    }
    beginDemo() {
      this.stopDemo();
      if (!this.heightEligible()) return;
      this.running = true; this.setAttribute('data-demo-running', ''); this.demoUI(true);
      if (this.value >= 99.5) this.dropCycle();
      else { this.setHeight(100, true); this.later(() => this.dropCycle(), 4300); }
    }
    dropCycle() {
      if (!this.running || !this.heightEligible()) { this.stopDemo(); return; }
      this.setHeight(0, true, 1000);
      this.later(() => this.setHeight(55, true, 1050), 4300);
      this.later(() => this.setHeight(100, true, 1050), 8200);
      this.later(() => this.dropCycle(), 14000);
    }
    stopDemo() {
      if (!this.timers) return;
      this.timers.forEach(clearTimeout); this.timers.clear(); this.pendingDemo = null;
      cancelAnimationFrame(this.frame); this.frame = null;
      if (typeof this.value === 'number' && this.value !== this.goal) this.setHeight(this.value, false);
      this.running = false; this.removeAttribute('data-demo-running');
      this.demoUI(false); this.setFlow('hold');
    }
    buildRoadTrack() {
      // Draw the long road once. The scene scrolls by translating its SVG group.
      // Compensating Y maintains a constant shallow perspective slope.
      const start = -420, end = 4240, step = 16, points = [];
      for (let x = start; x < end; x += step) {
        points.push([x, 754 + x * .0573 - this.roadHeight(x, 0)]);
      }
      points.push([end, 754 + end * .0573 - this.roadHeight(end, 0)]);
      let path = 'M' + points[0][0] + ' ' + points[0][1].toFixed(2);
      for (let i = 1; i < points.length - 1; i++) {
        const p = points[i], n = points[i + 1];
        path += 'Q' + p[0] + ' ' + p[1].toFixed(2) + ' ' +
          ((p[0] + n[0]) / 2).toFixed(2) + ' ' +
          ((p[1] + n[1]) / 2).toFixed(2);
      }
      const last = points[points.length - 1];
      path += 'L' + last[0] + ' ' + last[1].toFixed(2);
      this.roadSurface.setAttribute('d', path);
      this.roadFill.setAttribute('d', path + 'L' + end + ' 1600L' + start + ' 1600Z');
      this.roadLane.setAttribute('d', 'M' + start + ' ' + (828 + start * .0573).toFixed(2) +
        'L' + end + ' ' + (828 + end * .0573).toFixed(2));
    }
    roadHeight(x, travel) {
      const spacing = 2100;
      const distance = center => Math.abs(((x + travel - center + spacing / 2) % spacing + spacing) % spacing - spacing / 2);
      const bumpDistance = distance(1450);
      // Compact daily-driving bump: modest height, rounded into the road.
      const bump = bumpDistance < 135 ? 18 * Math.pow(.5 + .5 * Math.cos(bumpDistance * Math.PI / 135), 2) : 0;
      const holeDistance = distance(460);
      // Short, shallow pothole with eased shoulders to avoid sudden wheel jumps.
      const shoulder = Math.max(0, Math.min(1, (holeDistance - 75) / 40));
      const eased = shoulder * shoulder * (3 - 2 * shoulder);
      const hole = holeDistance < 115 ? -28 * (1 - eased) : 0;
      return bump + hole;
    }
    wheelHeight(x, travel, radius) {
      // A small blended tyre footprint prevents snapping across edges
      // and removes repeated square roots from each animation frame.
      const shoulder = radius > 125 ? 42 : 35;
      return this.roadHeight(x, travel) * .54 +
        (this.roadHeight(x - shoulder, travel) + this.roadHeight(x + shoulder, travel)) * .23;
    }
    renderRoad(front, rear, body, pitch, travel) {
      this.roadNodes.front.setAttribute('transform', 'translate(0,' + (-front).toFixed(2) + ')');
      this.roadNodes.rear.setAttribute('transform', 'translate(0,' + (-rear).toFixed(2) + ')');
      this.roadNodes.body.setAttribute('transform', 'translate(0,' + (-.4 - body).toFixed(2) + ') rotate(' + pitch.toFixed(3) + ' 550 640)');
      const rotation = (travel / 145 * 180 / Math.PI) % 360;
      this.rims.forEach(rim => rim.setAttribute('transform', 'rotate(' + rotation.toFixed(2) + ')'));
      if (!this.mobileMotion) {
        const reflection = travel % 1900 / 1900;
        this.glint.setAttribute('transform', 'translate(' + (-300 + reflection * 2130).toFixed(2) + ',0)');
        this.glint.setAttribute('opacity', (.065 * Math.pow(Math.sin(Math.PI * reflection), 2)).toFixed(3));
      } else if (this.glint.getAttribute('opacity') !== '0') {
        this.glint.setAttribute('opacity', '0');
      }
      const distance = ((travel % 2100) + 2100) % 2100;
      this.roadTrack.setAttribute('transform', 'translate(' + (-distance).toFixed(2) + ',' +
        (-distance * .0573).toFixed(2) + ')');
      // A very small camera-relative movement makes the car feel in motion.
      const sway = Math.sin(travel / 500) * 18 + Math.sin(travel / 1100) * 6;
      const settle = Math.sin(travel / 260) * 1.2;
      this.rideVehicle.setAttribute('transform', 'translate(' + sway.toFixed(2) + ',' + settle.toFixed(2) + ')');
      // Keep the small road-test label stable; visual road movement tells the story.
      const compression = front - (body - 217 * Math.sin(pitch * Math.PI / 180));
      this.renderStrut(this.rideNodes, compression * (compression < 0 ? 2.05 : 2.6));
      this.roadNodes.travel.style.transform = 'translateY(' + Math.max(-18, Math.min(18, compression * .7)).toFixed(2) + 'px)';
    }
    startRoad() {
      if (!this.assetsReady || this.reduced.matches || this.dataset.view !== 'ride' || document.hidden) return;
      if (this.roadState.travel < 1) this.roadState.travel = 1290;
      this.roadRunning = true; this.setAttribute('data-road-running', '');
      this.querySelector('[data-road-toggle]').setAttribute('aria-pressed', 'true');
      this.querySelector('[data-road-label]').textContent = this.dataset.roadStop;
      this.querySelector('[data-road-toggle] .om2__play').textContent = 'Ⅱ';
      let last = performance.now();
      const step = now => {
        if (!this.roadRunning) return;
        const elapsed = Math.max(.001, Math.min(.075, (now - last) / 1000)); last = now;
        const state = this.roadState;
        // Subdivide slower iPhone frames so wheel/body physics remain even and
        // the suspension never jumps when Safari skips a paint frame.
        const steps = Math.max(1, Math.ceil(elapsed / .016));
        const dt = elapsed / steps;
        for (let n = 0; n < steps; n++) {
          state.travel += dt * 1180;
          const sway = Math.sin(state.travel / 500) * 18 + Math.sin(state.travel / 1100) * 6;
          const contactFront = this.wheelHeight(767 + sway, state.travel, 145);
          const contactRear = this.wheelHeight(129 + sway, state.travel, 113);
          const following = 1 - Math.exp(-dt * 11.8);
          state.frontSuspension += (Math.max(-25, Math.min(20, contactFront)) - state.frontSuspension) * following;
          state.rearSuspension += (Math.max(-25, Math.min(20, contactRear)) - state.rearSuspension) * following;
          const front = state.frontSuspension, rear = state.rearSuspension;
          const target = (front * .58 + rear * .42) * .78;
          state.velocity += ((target - state.body) * 105 - state.velocity * 18) * dt;
          state.body += state.velocity * dt;
          const targetPitch = Math.max(-.3, Math.min(.3, Math.atan2(rear - front, 638) * 180 / Math.PI * .16));
          state.pitchVelocity += ((targetPitch - state.pitch) * 26 - state.pitchVelocity * 11) * dt;
          state.pitch += state.pitchVelocity * dt;
        }
        this.renderRoad(state.frontSuspension, state.rearSuspension, state.body, state.pitch, state.travel);
        this.roadFrame = requestAnimationFrame(step);
      };
      this.roadFrame = requestAnimationFrame(step);
    }
    stopRoad(reset = false) {
      cancelAnimationFrame(this.roadFrame); this.roadFrame = null;
      this.roadRunning = false; this.removeAttribute('data-road-running');
      this.querySelector('[data-road-toggle]').setAttribute('aria-pressed', 'false');
      this.querySelector('[data-road-label]').textContent = this.dataset.roadPlay;
      this.querySelector('[data-road-toggle] .om2__play').textContent = '▶';
      if (reset) {
        this.roadState = { travel: 1290, body: 0, velocity: 0, pitch: 0, pitchVelocity: 0, frontSuspension: 0, rearSuspension: 0 }; this.renderRoad(0, 0, 0, 0, 1290);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-service-centre"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('onair-service-centre')) return;
  customElements.define('onair-service-centre', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.querySelector('form.osc__form');
      if (!this.form || !this.querySelector('[data-osc-panel]')) return;
      try {
        const config = JSON.parse(this.querySelector('[data-osc-config]').textContent);
        const entities = {'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'",'&#x27;':"'"};
        this.words = Object.fromEntries(Object.entries(config).map(([key,value]) => [key,String(value).replace(/&(?:amp|lt|gt|quot|#39|#x27);/g,entity => entities[entity])]));
      } catch { return; }
      this.bound = true;
      this.step = 0;
      this.furthest = 0;
      this.panels = [...this.querySelectorAll('[data-osc-panel]')];
      this.stepButtons = [...this.querySelectorAll('[data-osc-step]')];
      this.paths = [...this.querySelectorAll('[data-osc-path]')];
      this.dataset.enhanced = 'true';
      this.querySelector('[data-osc-progress]')?.removeAttribute('hidden');
      this.querySelector('.osc__progress').hidden = false;
      this.querySelectorAll('[data-guided-only],[data-osc-back]').forEach(el => { el.hidden = false; });
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = type => parts.find(p => p.type === type)?.value || '';
      const today = `${part('year')}-${part('month')}-${part('day')}`;
      this.querySelectorAll('[data-preferred-date]').forEach(input => { input.min = today; });
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form.addEventListener('input', () => { this.updateConditions(); this.updateSummary(); this.hidePreview(); }, {signal});
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-service]')) {
          this.querySelector('[data-service-error]').hidden = true;
          this.paths.forEach(path => {
            if (path.dataset.oscPath !== this.serviceKey()) {
              path.querySelectorAll('input,select,textarea').forEach(control => { if (control.type === 'checkbox' || control.type === 'radio') control.checked = false; else control.value = ''; });
            }
          });
        }
        this.updateConditions(); this.updateSummary(); this.hidePreview();
      }, {signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-osc-next')) {
          if (this.validateStep(this.step)) this.showStep(this.step + 1, true);
        } else if (button.hasAttribute('data-osc-back')) {
          this.showStep(Math.max(0, this.step - 1), true);
        } else if (button.hasAttribute('data-osc-step')) {
          const target = Number(button.dataset.oscStep);
          if (target < this.step || this.validateThrough(target - 1)) this.showStep(target, true);
        } else if (button.hasAttribute('data-osc-edit')) {
          this.showStep(1, true);
        } else if (button.hasAttribute('data-osc-final')) {
          if (!this.validateThrough(2)) { event.preventDefault(); return; }
          this.updateSummary();
          if (this.dataset.acceptRequests !== 'true') {
            event.preventDefault();
            const result = this.querySelector('[data-osc-preview-result]');
            result.hidden = false; result.focus({preventScroll:true});
            result.scrollIntoView({behavior:this.motion(),block:'nearest'});
          }
        }
      }, {signal});
      this.form.addEventListener('submit', event => {
        if (this.dataset.acceptRequests !== 'true') { event.preventDefault(); return; }
        if (!this.validateThrough(2)) { event.preventDefault(); return; }
        this.updateSummary();
      }, {signal});
      this.form.addEventListener('invalid', event => {
        const panel = event.target.closest('[data-osc-panel]');
        if (panel && !this.checking) this.showStep(Number(panel.dataset.oscPanel), false);
      }, {capture:true,signal});
      this.updateConditions();
      this.updateSummary();
      this.showStep(0, false);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.bound = false;
    }
    serviceKey() { return this.querySelector('[data-service]:checked')?.dataset.service || ''; }
    answer(key) {
      const control = this.querySelector(`[data-osc-key="${key}"]`);
      if (!control || control.disabled) return '';
      return control.selectedOptions?.[0]?.dataset.answer || control.value;
    }
    setCondition(wrapper, active) {
      if (!wrapper) return;
      wrapper.hidden = !active;
      wrapper.querySelectorAll('input,select,textarea').forEach(control => {
        control.disabled = !active;
        control.required = active && control.dataset.conditionRequired === 'true';
        if (control.required) control.setAttribute('aria-required','true'); else control.removeAttribute('aria-required');
        if (!active) {
          if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
          else control.value = '';
        }
      });
    }
    updateConditions() {
      const selected = this.serviceKey();
      this.paths.forEach(path => {
        const active = path.dataset.oscPath === selected;
        path.hidden = !active; path.disabled = !active;
        path.querySelectorAll('[data-diagnostic]').forEach(control => {
          const condition = control.dataset.ifKey;
          const relevant = active && (!condition || control.dataset.ifValues.split(',').includes(this.answer(condition)));
          const field = control.closest('.osc__field');
          field.hidden = !relevant;
          control.disabled = !relevant;
          control.required = relevant && control.dataset.conditionRequired === 'true';
          if (control.required) control.setAttribute('aria-required','true'); else control.removeAttribute('aria-required');
          if (!relevant) control.value = '';
        });
      });
      const parts = this.answer('parts') === 'yes';
      this.setCondition(this.querySelector('[data-parts-details]'), parts);
      const warranty = this.querySelector('[data-warranty-toggle]').checked;
      this.setCondition(this.querySelector('[data-warranty-details]'), warranty);
      const phone = this.querySelector('[data-osc-key="phone"]');
      const phoneRequired = this.answer('method') !== 'email';
      phone.required = phoneRequired;
      if (phoneRequired) phone.setAttribute('aria-required','true'); else phone.removeAttribute('aria-required');
      phone.previousElementSibling.textContent = phoneRequired ? this.words.phoneRequired : this.words.phone;
      this.querySelector('[data-mobility-warning]').hidden = this.answer('mobility') !== 'problem';
      this.querySelectorAll('[data-extra-service]').forEach(label => {
        const same = label.dataset.extraService === selected;
        label.hidden = same;
        label.querySelector('input').disabled = same;
        if (same) label.querySelector('input').checked = false;
      });
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    showStep(step, focus) {
      this.step = Math.max(0,Math.min(2,step));
      this.furthest = Math.max(this.furthest,this.step);
      this.panels.forEach((panel,index) => { panel.hidden = index !== this.step; });
      this.stepButtons.forEach((button,index) => {
        button.disabled = index > this.furthest;
        if (index === this.step) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-osc-status]').textContent = this.words.step_status.replace('__STEP__',String(this.step+1)).replace('__TITLE__',[this.words.step_service,this.words.step_details,this.words.step_review][this.step]);
      if (focus) {
        this.panels[this.step].querySelector('h2')?.focus({preventScroll:true});
        this.querySelector('.osc__progress').scrollIntoView({behavior:this.motion(),block:'start'});
      }
    }
    validateStep(step) {
      if (step === 0 && !this.serviceKey()) {
        this.showStep(0, false);
        this.querySelector('[data-service-error]').hidden = false;
        this.querySelector('[data-service]')?.focus();
        return false;
      }
      this.checking = true;
      const controls = [...this.panels[step].querySelectorAll('input,select,textarea')];
      const invalid = controls.find(control => !control.disabled && control.willValidate && !control.checkValidity());
      this.checking = false;
      if (invalid) { this.showStep(step,false); invalid.reportValidity(); invalid.focus(); return false; }
      return true;
    }
    validateThrough(step) {
      for (let index = 0; index <= step; index++) if (!this.validateStep(index)) return false;
      return true;
    }
    summaryRows() {
      return [...this.form.querySelectorAll('[data-summary-label]')].filter(control => {
        if (control.disabled || control.closest('fieldset:disabled')) return false;
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return false;
        return String(control.value || '').trim() !== '';
      }).map(control => ({group:control.dataset.summaryGroup,label:control.dataset.summaryLabel.replace(/\s*\*$/,''),value:String(control.value).trim()}));
    }
    updateSummary() {
      const rows = this.summaryRows();
      const summary = this.querySelector('[data-osc-summary]');
      summary.replaceChildren();
      const service = this.querySelector('[data-service]:checked')?.value || '';
      this.querySelector('[data-summary-service]').textContent = service;
      const lines = [this.form.querySelector('input[name="contact[Request type]"]').value];
      const headings = {service:this.words.summary_service,vehicle:this.words.summary_vehicle,contact:this.words.summary_contact};
      for (const group of ['service','vehicle','contact']) {
        const groupRows = rows.filter(row => row.group === group);
        if (!groupRows.length) continue;
        const heading = document.createElement('h4');heading.textContent=headings[group];summary.append(heading);
        const list = document.createElement('dl');summary.append(list);
        lines.push('',headings[group]);
        groupRows.forEach(row => {
          const pair=document.createElement('div');const term=document.createElement('dt');const value=document.createElement('dd');
          term.textContent=row.label;value.textContent=row.value;pair.append(term,value);list.append(pair);
          lines.push(`${row.label}: ${row.value}`);
        });
      }
      this.querySelector('[data-osc-body]').value=lines.join('\n');
    }
    hidePreview() { this.querySelector('[data-osc-preview-result]').hidden = true; }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-v3-installation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mounted = new WeakSet();
  const mount = root => {
    if (mounted.has(root)) return;
    mounted.add(root);
    const update = (announce = false) => {
      const tier = root.querySelector('[data-install-tier]:checked')?.value || '';
      const style = root.querySelector('[data-install-style]:checked')?.value || '';
      root.querySelectorAll('[data-install-tier-summary]').forEach(el => { el.textContent = tier; });
      root.querySelectorAll('[data-install-style-summary]').forEach(el => { el.textContent = style; });
      if (announce) {
        const status = root.querySelector('[data-install-announcement]');
        if (status) status.textContent = [tier, style].filter(Boolean).join(' · ');
      }
    };
    const contact = root.querySelector('[data-install-contact]');
    const phone = root.querySelector('[data-install-phone]');
    const updateContact = () => {
      if (!contact || !phone) return;
      phone.required = Boolean(contact.selectedOptions[0]?.hasAttribute('data-phone-option'));
      const label = root.querySelector('[data-install-phone-label]');
      if (label) label.textContent = phone.required ? label.dataset.phoneRequired : label.dataset.phoneOptional;
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[data-install-tier], [data-install-style]')) update(true);
      if (event.target.matches('[data-install-contact]')) updateContact();
    });
    root.addEventListener('reset', () => requestAnimationFrame(() => { update(); updateContact(); }));
    update();
    updateContact();
  };
  const scan = scope => {
    if (scope.matches?.('[data-installation-planner]')) mount(scope);
    scope.querySelectorAll('[data-installation-planner]').forEach(mount);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-installation-planner]').forEach(root => {
    root.querySelector('[data-install-tier]:checked')?.dispatchEvent(new Event('change', { bubbles: true }));
    root.querySelector('[data-install-contact]')?.dispatchEvent(new Event('change', { bubbles: true }));
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-v3-management-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-amg-demo]').forEach(demo => {
      if (demo.dataset.amgReady) return;
      demo.dataset.amgReady = 'true';
      const groups = {front:['fl','fr'], rear:['rl','rr'], all:['fl','fr','rl','rr'], fl:['fl'], fr:['fr'], rl:['rl'], rr:['rr']};
      demo.addEventListener('click', event => {
        const button = event.target.closest('[data-amg-select]');
        if (!button || !demo.contains(button)) return;
        const selected = button.dataset.amgSelect;
        const corners = groups[selected] || [];
        demo.dataset.selection = selected;
        demo.querySelectorAll('[data-amg-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        demo.querySelectorAll('[data-amg-corner]').forEach(item => item.classList.toggle('is-active', corners.includes(item.dataset.amgCorner)));
        demo.querySelectorAll('[data-amg-line]').forEach(item => {
          const line = item.dataset.amgLine;
          const active = line === 'front' ? corners.includes('fl') && corners.includes('fr') : line === 'rear' ? corners.includes('rl') && corners.includes('rr') : corners.includes(line);
          item.classList.toggle('is-active', active);
        });
        demo.querySelector('[data-amg-status]').textContent = button.dataset.amgMessage;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-v75-2v-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function enhance(){
    document.querySelectorAll('[data-ov75-landing] a[data-ov75-preserve-utm]').forEach(function(a){
      if(a.dataset.utmCopied==='1')return;
      var target;
      try{target=new URL(a.href,location.origin);}catch(e){return;}
      if(target.origin!==location.origin)return;
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
        var v=new URLSearchParams(location.search).get(k);
        if(v&&!target.searchParams.has(k))target.searchParams.set(k,v.slice(0,140));
      });
      a.href=target.toString();a.dataset.utmCopied='1';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onair-v75-purchase-help"] && !Shopify.designMode) return;
  try {
    
(function(){
  function preserveLeadSource(){
    var params=new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ov75-lead-utm]').forEach(function(field){
      var key=field.getAttribute('data-ov75-lead-utm');
      var value=params.get(key)||'';
      field.value=value.slice(0,140);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',preserveLeadSource,{once:true});
  else preserveLeadSource();
  document.addEventListener('shopify:section:load',preserveLeadSource);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();
})();
